import axios, { AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios';
import { LocalStorageKeys } from '@common/constants';
import { notification } from 'antd';

let migrationMessageShown = false;
const federatedUserToken = sessionStorage.getItem(LocalStorageKeys.X_USER_TOKEN);

const axiosInstance: AxiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_API_VERSION}`,
  headers: {
    'Content-Type': 'application/json',
  },
});

if (federatedUserToken) {
  axiosInstance.interceptors.request.use(async (req: AxiosRequestConfig) => {
    req.headers = {
      ...req.headers,
      Authorization: `Token ${federatedUserToken}`,
      'X-User-Email': JSON.parse(localStorage.getItem(LocalStorageKeys.USER_EMAIL) || ''),
    };

    return req;
  });
}

axiosInstance.interceptors.response.use(
  (res) => res,
  async (error: AxiosError) => {
    if (error.response?.status === 406 && !migrationMessageShown) {
      notification.warn({
        message: 'Service line under migration process',
        description: 'Service line is currently under migration. Please, visit the page later.',
        placement: 'bottom',
        duration: 10,
      });

      migrationMessageShown = true;
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
